import { ClientName } from './types';
import { currentUserKey } from '@/shared/msw-constants';

export const steps = {
  ACTIVATE_STEP : 'activateStep',
  SETUP_EMAIL_STEP: 'setupEmailStep',
  SETUP_APP_STEP: 'setupAppStep',
};

export const CLIENT_NAMES: ClientName = {
  MYSONICWALL: 'MYSONICWALL',
  SPOG: 'Capture Security Center',
} as const;

export const getValueFromCurrentUser = (value: string) => {
  try {
    const rowCurrentUser = localStorage.getItem(currentUserKey) || '';
    const parsedUser = rowCurrentUser && JSON.parse(rowCurrentUser);
    return (parsedUser && parsedUser[value]) || null;
  } catch (e) {
    console.error(e);
  }
};

export const isGuestUser = () =>  {
  const isGuestUsercheckBytoken: boolean = (getValueFromCurrentUser('userId') &&
    getValueFromCurrentUser('userId') === 'GUESTBUYNOW');
  const isGuestUsercheckByQuery: boolean = location.search.includes('isGuestBuynow') ? true : false;
  return isGuestUsercheckByQuery || isGuestUsercheckBytoken;
};
